import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { formatToZMW, rootUrl } from '../../../helpers';
import { FaFolderOpen } from 'react-icons/fa';

export default function Projects() {

    const [projects, setProjects] = useState([]);


    const fetchData = async () =>{

        const data = await axios.get(rootUrl(`/getAllProjects`))

        setProjects(data.data.data)

        console.log(data.data.data)


    }

    useEffect(()=>{
        fetchData()
    },[])

  return (
    <div className="container mx-auto p-4">
    <h1 className="text-2xl font-semibold text-gray-800 mb-4">Project Report</h1>
    <div className="overflow-x-auto shadow-lg rounded-lg">
      <table className="min-w-full bg-white border border-gray-300">
        <thead className="bg-gray-200 text-gray-700">
          <tr>
        
            <th className="px-4 py-2 text-left text-sm font-medium">Name</th>
            <th className="px-4 py-2 text-left text-sm font-medium">Constituency</th>
            <th className="px-4 py-2 text-left text-sm font-medium">Type</th>
            <th className="px-4 py-2 text-left text-sm font-medium">Amount</th>
            <th className="px-4 py-2 text-left text-sm font-medium">Paid</th>
            <th className="px-4 py-2 text-left text-sm font-medium">Balance</th>
            
            
          </tr>
        </thead>
        <tbody>
          {projects.length > 0 ? (
            projects.map((item) => (
              <tr key={item.id} className="border-t hover:bg-gray-100">
                <td className="px-4 py-2 text-sm text-gray-800">{item.name}</td>
                <td className="px-4 py-2 text-sm text-gray-800">{item.constituency}</td>
                <td className="px-4 py-2 text-sm text-gray-800">{item.head}</td>
                <td className="px-4 py-2 text-sm text-gray-800">{formatToZMW(item.amount)}</td>
                <td className="px-4 py-2 text-sm text-gray-800">{formatToZMW(item.cash!== null?item.cash:0)}</td>
                <td className="px-4 py-2 text-sm text-gray-800">{formatToZMW(parseFloat(item.amount) - parseFloat(item.cash!== null?item.cash:0))}</td>
                
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="9"
                className="px-4 py-2 text-center text-gray-500 text-sm"
              >
                <div className="flex flex-col justify-center items-center">
                    <FaFolderOpen className="text-gray-500 text-6xl mb-2" />
                    <p className="text-gray-600">No projects found</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
  )
}
